export const ERTZYX_LOGO_SRC = '/brand/ertzyx-logo.png';
// Tightly cropped, wordmark-free emblem for small square brand marks
// (sidebar/toolbar icon containers) where the full logo+wordmark can't fit legibly.
export const ERTZYX_EMBLEM_SRC = '/brand/ertzyx-emblem.png';
